var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g, _path15, _path16, _path17, _path18, _path19, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMiniLibrary04(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 253,
    viewBox: "0 0 259 253",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.304688,
    y: 0.310547,
    width: 258,
    height: 252,
    fill: "#C275A3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_502_15125",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 253
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.304688,
    y: 0.310547,
    width: 258,
    height: 252,
    fill: "#D6895E"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_502_15125)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M227.321 195.103L338.531 144.127L338.53 149.434L227.32 200.41L227.321 195.103Z",
    fill: "#3C6388"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M227.314 195.059L73.5811 127.447L73.5801 132.754L227.313 200.366L227.314 195.059Z",
    fill: "#2B4A67"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M200.096 212.401L46.3633 144.789L73.5746 132.746L227.307 200.358L200.096 212.401Z",
    fill: "#1C3043"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4707 127.449L184.68 76.4727L261.661 110.287L150.451 161.263L73.4707 127.449Z",
    fill: "#4D85B9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4707 127.449L184.68 76.4727L261.661 110.287L150.451 161.263L73.4707 127.449Z",
    fill: "url(#paint0_linear_502_15125)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M150.342 161.261L261.551 110.285L338.532 144.1L227.322 195.076L150.342 161.261Z",
    fill: "#4D85B9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M150.342 161.261L261.551 110.285L338.532 144.1L227.322 195.076L150.342 161.261Z",
    fill: "url(#paint1_linear_502_15125)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M155.241 141.054L82.9363 108.814L82.9316 126.652L155.237 158.891L155.241 141.054Z",
    fill: "#A5ABB0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M155.241 141.054L82.9363 108.814L82.9316 126.652L155.237 158.891L155.241 141.054Z",
    fill: "url(#paint2_linear_502_15125)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M227.547 173.308L155.242 140.887V159.014L227.547 191.253V173.308Z",
    fill: "#A5ABB0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M227.547 173.308L155.242 140.887V159.014L227.547 191.253V173.308Z",
    fill: "url(#paint3_linear_502_15125)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M227.554 173.437L329.278 125.775L329.274 143.613L227.549 191.275L227.554 173.437Z",
    fill: "#C9DDF0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M227.613 173.267L82.9375 108.841L184.691 61.3379L329.309 125.772L227.613 173.267Z",
    fill: "#F2F9FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_502_15125",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 113,
    y: 69,
    width: 89,
    height: 50
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M140.187 118.861L113.389 104.338L174.395 69.1094L201.193 83.6331L140.187 118.861Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_502_15125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.126 106.599C133.028 106.653 132.941 106.708 132.833 106.762L129.845 108.294L122.328 103.872L125.305 102.341C127.825 101.059 130.541 101.309 132.746 102.623C134.918 103.883 135.298 105.35 133.126 106.61M114.322 103.818L136.645 116.951L140.86 114.779L133.582 110.499L137.232 108.62C137.417 108.522 137.601 108.424 137.775 108.326C141.892 105.947 141.382 102.895 137.102 100.385C132.702 97.8001 126.923 97.3222 122.306 99.712L114.333 103.818",
    fill: "#D1DFEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.951 104.186C149.767 104.87 149.898 106.043 151.288 106.826C152.69 107.684 154.916 107.814 156.242 107.13C156.274 107.108 156.307 107.097 156.339 107.075C157.48 106.424 157.371 105.229 155.981 104.403C154.558 103.567 152.32 103.447 151.082 104.099C151.028 104.121 150.984 104.153 150.941 104.175",
    fill: "#D1DFEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.22 93.6626C158.122 93.7169 158.024 93.7712 157.916 93.8255L154.939 95.3572L147.411 90.9251L150.388 89.3935C152.908 88.1117 155.624 88.3615 157.829 89.6759C160.001 90.936 160.392 92.4025 158.22 93.6517M139.405 90.86L161.729 104.004L165.943 101.831L158.665 97.5515L162.315 95.6722C162.5 95.5745 162.674 95.4767 162.837 95.3898C166.965 93.0108 166.454 89.9583 162.174 87.4382C157.775 84.8528 151.995 84.3748 147.368 86.7538L139.395 90.86",
    fill: "#D1DFEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.24 81.6791L179.574 94.8231L183.724 92.6832L161.401 79.5391L157.24 81.6791Z",
    fill: "#D1DFEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.878 79.9524L180.393 83.2982C178.622 82.1685 178.34 80.6259 180.045 79.6374C180.11 79.594 180.186 79.5614 180.262 79.5179C182.098 78.5511 184.836 78.7575 186.889 79.9416M176.319 77.7799C172.322 80.0828 173.049 83.5046 178.057 86.4376C183.347 89.5661 189.528 90.0441 194.221 87.6434C194.384 87.5565 194.547 87.4696 194.699 87.3827C198.001 85.4708 198.382 83.1244 195.981 81.0822L192.027 83.1244C192.592 83.8848 192.309 84.7647 191.06 85.4925C191.006 85.5251 190.951 85.5577 190.886 85.5903C188.725 86.6874 185.802 86.4702 183.271 84.982L193.689 79.6157L192.385 78.8553C186.682 75.4987 180.74 75.4878 176.743 77.5517C176.591 77.6278 176.45 77.7038 176.308 77.7907",
    fill: "#D1DFEB"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M227.734 173.554L155.242 140.935L256.965 93.4258L329.457 126.045L227.734 173.554Z",
    fill: "#EAF5FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M227.734 173.554L155.242 140.935L256.965 93.4258L329.457 126.045L227.734 173.554Z",
    fill: "url(#paint4_linear_502_15125)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M214.875 126.964L155.242 140.926L256.965 93.4166L316.598 79.4553L214.875 126.964Z",
    fill: "#E4EEF7"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M214.875 126.964L155.242 140.926L256.965 93.4166L316.598 79.4553L214.875 126.964Z",
    fill: "url(#paint5_linear_502_15125)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M181.973 242.311V222.514H189.738C194.236 222.514 196.82 225.289 196.82 229.186C196.82 233.137 194.195 235.857 189.629 235.857H186.074V242.311H181.973ZM186.074 232.549H188.973C191.406 232.549 192.596 231.182 192.582 229.186C192.596 227.217 191.406 225.891 188.973 225.877H186.074V232.549ZM200.785 242.557C199.5 242.557 198.461 241.531 198.488 240.26C198.461 239.002 199.5 237.977 200.785 237.99C202.002 237.977 203.055 239.002 203.055 240.26C203.055 241.531 202.002 242.557 200.785 242.557ZM206.391 242.311V222.514H214.156C218.654 222.514 221.238 225.289 221.238 229.186C221.238 233.137 218.613 235.857 214.047 235.857H210.492V242.311H206.391ZM210.492 232.549H213.391C215.824 232.549 217.014 231.182 217 229.186C217.014 227.217 215.824 225.891 213.391 225.877H210.492V232.549ZM227.801 222.514V242.311H223.754V222.514H227.801ZM237.672 242.611C233.119 242.598 230.33 239.658 230.344 234.955C230.33 230.375 233.16 227.271 237.508 227.271C241.404 227.271 244.48 229.732 244.48 234.791V235.939H234.336C234.336 238.182 235.662 239.562 237.754 239.576C239.135 239.562 240.119 238.961 240.516 238.072H244.371C243.797 240.82 241.336 242.598 237.672 242.611ZM234.336 233.396H240.652C240.639 231.592 239.395 230.293 237.59 230.307C235.73 230.293 234.418 231.688 234.336 233.396Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_502_15125",
    x1: 144.622,
    y1: 97.9163,
    x2: 167.566,
    y2: 161.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D85B9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2264A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_502_15125",
    x1: 180.813,
    y1: 141.141,
    x2: 222.469,
    y2: 173.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2264A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D85B9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_502_15125",
    x1: 155.242,
    y1: 152.111,
    x2: 82.9316,
    y2: 120.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82878B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5ABB0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_502_15125",
    x1: 155.242,
    y1: 150.939,
    x2: 227.548,
    y2: 184.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#858C92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5ABB0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_502_15125",
    x1: 218.181,
    y1: 117.318,
    x2: 232.961,
    y2: 176.257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8B1B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF5FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_502_15125",
    x1: 214.145,
    y1: 103.828,
    x2: 233.347,
    y2: 140.933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C7CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4EEF6",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniLibrary04);
export default __webpack_public_path__ + "static/media/mini_library_04.fe82e92e8e2c6785ab3511eed678f0bb.svg";
export { ForwardRef as ReactComponent };